import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _IonImageryCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, makeObservable, observable, runInAction } from "mobx";
import IonImageryProvider from "terriajs-cesium/Source/Scene/IonImageryProvider";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import IonImageryCatalogItemTraits from "../../../Traits/TraitsClasses/IonImageryCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
let IonImageryCatalogItem = (_class = (_IonImageryCatalogItem = class IonImageryCatalogItem extends MappableMixin(CatalogMemberMixin(CreateModel(IonImageryCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "_imageryProvider", _descriptor, this);
    makeObservable(this);
  }
  get type() {
    return IonImageryCatalogItem.type;
  }
  forceLoadMapItems() {
    if (!isDefined(this.ionAssetId)) return Promise.resolve();
    const attribution = this.attribution;
    return IonImageryProvider.fromAssetId(this.ionAssetId, {
      accessToken: this.ionAccessToken || this.terria.configParameters.cesiumIonAccessToken,
      server: this.ionServer
    }).then(imageryProvider => {
      if (attribution) {
        imageryProvider._credit = attribution;
      }
      runInAction(() => {
        this._imageryProvider = imageryProvider;
      });
    }).catch(e => {
      this._imageryProvider = undefined;
      throw e;
    });
  }
  get mapItems() {
    if (!isDefined(this._imageryProvider)) {
      return [];
    }
    return [{
      show: this.show,
      alpha: this.opacity,
      imageryProvider: this._imageryProvider,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    }];
  }
}, _defineProperty(_IonImageryCatalogItem, "type", "ion-imagery"), _IonImageryCatalogItem), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_imageryProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
export { IonImageryCatalogItem as default };